import { injectable } from "inversify";
import ValidationResult from "./ValidationResult";

@injectable()
export abstract class BaseValidator<T> {
    public abstract Validate(entity: T): ValidationResult;
}